import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const ColumnFieldsQueryGql: DocumentNode = gql`
query ColumnFieldsQuery($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: { id: $columnId }) {
    referencedByFieldsConnection(first: $first, offset: $offset, orderBy: { field: NAME, direction: ASC }) {
      totalCount
      nodes {
        id
        name
        datasource {
          name
          ... on PublishedDatasource {
            vizportalUrlId
          }
          ... on EmbeddedDatasource {
            id
            workbook {
              vizportalUrlId
            }
          }
        }
      }
    }
  }
}
`;
